<template>
    <div ref="dropdown" :class="['custom-select-container', theme]">
        <label :class="['custom_label', { 'label_margin': label != '' }]">{{ label }}</label>
        <div class="custom-dropdown">
            <!-- Etiqueta principal -->
            <div class="dropdown_label_select selected_label is-flex is-justify-content-flex-start"
                @click="toggleDropdown"
                v-bind:class="{ 'dropdown_label_select_clicked': isOpen && getExportListCheckbox().length == 0, 'dropdown_background_selected_items': getExportListCheckbox().length > 0 }">
                <span v-if="currentIcon != ''" class="svg-icon iconDefault">
                    <component :is="getCurrentIcon" />
                </span>
                <span v-if="staticLabel != ''" class="ml-1">
                    {{ staticLabel }}
                </span>
                <span v-else class="ml-1">{{ selectedLabel }}</span>
                <span v-if="isSearchable" class="ml-1 iconDefault"
                    :class="{ 'iconWhite': getExportListCheckbox().length > 0 }">
                    <RobotFace />
                </span>

            </div>

            <!-- Menú desplegable -->
            <transition name="slide">
                <div v-if="theme == 'classification_theme' && isOpen" class="dropdown_menu_select dropdown_wide">
                    <ul class="list_list">
                        <div v-for="(option, index) in data" v-bind:key="option.value">
                            <li v-if="option.separator" class="dropdown_item dropdown_title">
                                <b-checkbox v-if="isSearchable" :value="checkboxSelected['2_' + option.level_2]"
                                    @input="($event) => handleCheckboxChange('2_' + option.level_2, index, $event)">
                                    {{ option.level_2 }}
                                </b-checkbox>
                                <span v-else>
                                    {{ option.level_2 }}
                                </span>
                            </li>
                            <li v-else :data-value="option.value" class="dropdown_item dropdown_subitem"
                                v-bind:class="{ 'selected-item-menu': checkboxSelected['3_' + option.label] }"
                                @click.stop="selectOption(option)">
                                <b-checkbox v-if="isSearchable" :value="checkboxSelected['3_' + option.label]"
                                    @input="($event) => handleCheckboxChange('3_' + option.label, index, $event)">
                                    {{ option.label }}
                                </b-checkbox>
                                <span v-else>{{ option.label }}</span>
                            </li>
                        </div>
                    </ul>
                </div>
                <div v-else-if="isOpen" class="dropdown_menu_select dropdown_normal">
                    <ul class="list_list">
                        <li v-for="(option, index) in data" :key="index" :data-value="option.value"
                            class="dropdown_item" v-bind:class="{ 'selected-item-menu': option.value === value }"
                            @click.stop="selectOption(option)">
                            {{ option.label }}
                        </li>
                    </ul>
                </div>
            </transition>

        </div>
    </div>
</template>

<script>

import ArrowDown from "@/components/svg/ArrowDown.vue";
import Calendar from "@/components/svg/Calendar.vue";
import RobotFace from "@/components/svg/RobotFace.vue";
import UploadFile from "@/components/svg/UploadFile.vue";

const order = ['Ventas', 'Costos', 'Gastos', 'No Operacional', 'Activos'];

export default {
    name: "SelectComponent",
    components: {
        ArrowDown,
        Calendar,
        RobotFace,
        UploadFile
    },
    props: {
        options: {
            type: Array,
            required: false,
            default: () => [],
        },
        weirdOptions: {
            type: Array,
            required: false,
            default: () => [],
        },
        value: {
            type: [String, Number, Object],
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
        currentIcon: {
            type: String,
            default: '',
        },
        theme: {
            type: String,
            default: 'default_theme'
        },
        isAccount: {
            type: Boolean,
            default: false,
        },
        isSearchable: {
            type: Boolean,
            default: false,
        },
        staticLabel: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isOpen: false,
            data: [],
            selectedLabel: '',
            checkboxSelected: {}
        };
    },
    computed: {
        getCurrentIcon() {
            return this.currentIcon === 'calendar' ? 'Calendar' : this.currentIcon;
        },
    },
    methods: {
        handleCheckboxChange(value, index, cbValue) {
            this.$set(this.checkboxSelected, value, cbValue)
            const [level, text] = value.split('_')
            if (level == '2') {
                for (let iData = index; iData < this.data.length; iData++) {
                    const item = this.data[iData];
                    if (item.level_2 != text) {
                        break
                    }
                    if (iData != index) {
                        this.$set(this.checkboxSelected, 3 + '_' + item.label, cbValue)
                    }
                }
            } else if (this.data[index].level_2 != '' && !this.data[index].label && value == '') {
                for (let iData = index; iData < this.data.length; iData++) {
                    const item = this.data[iData];
                    if (item.level_2 != this.data[index].level_2) {
                        break
                    }
                    if (iData != index) {
                        this.$set(this.checkboxSelected, 3 + '_' + item.label, false)
                    }
                }
            }

            const exported = this.getExportListCheckbox()
            this.checkboxSelected = { ...this.checkboxSelected }
            this.$emit('selectedValues', exported);
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option) {
            this.$emit('input', option.value);
            this.selectedLabel = option.label;
            if (!this.isSearchable) {
                this.isOpen = false;
            }

        },
        handleClickOutside(event) {
            // Verificar si el clic fue fuera del componente
            const dropdown = this.$refs.dropdown;
            if (dropdown && !dropdown.contains(event.target)) {
                this.isOpen = false;
            }
        },
        findLowestLevel1(list) {
            let min = list.length + 1;
            for (const elem of list) {
                const val = elem['level_1'];
                const io = order.indexOf(val);
                if (io >= 0 && io < min) {
                    min = io;
                }
                if (min == 0) {
                    break;
                }
            }
            return min;
        },
        actualSortAccounts(entries) {
            entries = entries.sort((valA, valB) => {
                var lowestA = order.indexOf(valA.level_1);
                var lowestB = order.indexOf(valB.level_1);
                if (lowestA == lowestB) {
                    lowestA = valA.level_2;
                    lowestB = valB.level_2;
                }
                return lowestA - lowestB;
            });
            return entries;
        },
        parseWeirdOptions(woarray) {
            const randomOptions = [];
            for (const option of Object.values(woarray)) {
                randomOptions.push({
                    separator: false, value: option.id, label: this.isAccount ? option.level_3 : option.name,
                    level_1: option.level_1, level_2: option.level_2
                });
            }
            // const sortedOptions = this.actualSortAccounts(randomOptions);
            const finalOptions = [];
            var last_level_2 = '';
            for (var ii = 0; ii < randomOptions.length; ii++) {
                if (this.isAccount) {
                    const curr_level_2 = randomOptions[ii]['level_2'];
                    if (last_level_2 != curr_level_2) {
                        last_level_2 = curr_level_2;
                        finalOptions.push({ separator: true, level_2: last_level_2 });
                    }
                }
                finalOptions.push(randomOptions[ii]);
            }
            const selected = finalOptions.find(option => option.value == this.value);
            this.selectedLabel = selected ? selected.label : this.theme == 'classification_theme' ? 'Sin Clasificar' : 'Seleccionar';
            return finalOptions;
        },
        getExportListCheckbox() {
            let exported = []
            Object.keys(this.checkboxSelected).forEach(cbSelected => {
                if (this.checkboxSelected[cbSelected]) {
                    const [level, text] = cbSelected.split('_')
                    level == '2' ? null : exported.push(text)
                }
            })
            return exported
        },
        clearCbList() {
            this.checkboxSelected = {}
            this.$emit('selectedValues', []);
        },
        deleteItemCbList(item) {
            const keyCbSelected = Object.keys(this.checkboxSelected).find(cbSelected => {
                return cbSelected.includes(item)
            })

            this.checkboxSelected[keyCbSelected] = null
            this.checkboxSelected = { ...this.checkboxSelected }
            const exported = this.getExportListCheckbox()
            this.$emit('selectedValues', exported);
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        if (this.weirdOptions && this.weirdOptions.length > 0) {
            this.data = this.parseWeirdOptions(this.weirdOptions);
        } else {
            this.data = this.options;
        }
        const selected = this.data.find(option => option.value === this.value);
        this.selectedLabel = selected ? selected.label : this.theme == 'classification_theme' ? 'Sin Clasificar' : 'Seleccionar';
    },
    watch: {
        weirdOptions: {
            handler(newVal) {
                if (newVal) {
                    setTimeout(() => {
                        this.data = this.parseWeirdOptions(newVal);
                    }, 5)
                }
            },
            immediate: true,
        },
        options: {
            handler(newVal) {
                this.data = newVal;
                const selected = this.data.find(option => option.value === this.value);
                this.selectedLabel = selected ? selected.label : this.theme == 'classification_theme' ? 'Sin Clasificar' : 'Seleccionar';
            }
        },
        value: {
            handler(new_value) {
                const selected = this.data.find(option => option.value === new_value);
                this.selectedLabel = selected ? selected.label : this.theme == 'classification_theme' ? 'Sin Clasificar' : 'Seleccionar';
            }
        },
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
};
</script>
<style lang="scss" scoped>
.default_theme {
    --background-color: #002e33;
    --background-hover: #185555;
    --background-click: #3b7a7a;
    --background-click-hover: #3b7a7a;
    --text-color-selected-items: #101828;
    --text-color: white;
    --color-border: #dcdcdc;
    --padding-vert: 12px;
    --padding-horz: 16px;
    --height: 46px;
}

.classification_theme {
    --background-color: white;
    --background-color-selected-items: #002e33;
    --text-color-selected-items: #101828;
    --background-hover: #185555;
    --background-click: #fffffa;
    --background-click-hover: #f8f8f8;
    --text-color: #333a48;
    --text-color-on-selected: white;
    --color-border: #dcdcdc;
    --padding-vert: 2px;
    --padding-horz: 8px;
    --height: 46px;
    text-transform: capitalize;
}

.report_theme {
    --background-color: white;
    --background-color-selected-items: #002e33;
    --text-color-selected-items: #00A9AD;
    --background-hover: #fcfcfa;
    --background-click: #fffffa;
    --background-click-hover: #f8f8f8;
    --text-color: #5C5C5C;
    --text-color-on-selected: #5C5C5C;
    --color-border: #EBEBEB;
    --padding-vert: 2px;
    --padding-horz: 8px;
    --height: 30px;
    text-transform: capitalize;
}

.custom-select-container {
    position: relative;
}


.custom_label {
    font-size: 0.9rem;
    color: #4a4a4a;
    display: block;
}

.dropdown_label_select {
    background-color: var(--background-color);
    color: var(--text-color);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    width: 100%;
    padding: var(--padding-vert) var(--padding-horz);
    // color: var(--text-color);
    user-select: none;

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    height: var(--height);
}

.dropdown_background_selected_items {
    background-color: var(--background-color-selected-items);
    color: var(--text-color-on-selected);
}

.iconWhite {
    filter: brightness(0) invert(1);
}

$select_transition: 0.1s;

.dropdown_label_select:hover {
    background-color: var(--background-hover) !important;
    transition: all $select_transition ease;
    color: var(--text-color-on-selected, --text-color);

    .iconDefault {
        filter: brightness(0) invert(1);
    }
}

.dropdown_label_select_clicked {
    background-color: var(--background-click);
    color: var(--text-color);
}

.dropdown_label_select_clicked:hover {
    background-color: var(--background-click-hover) !important;
    color: var(--text-color);
    transition: all $select_transition ease;

    .iconDefault {
        filter: none;
    }
}

.label_margin {
    margin-bottom: 0.5rem;
}

.actual_button_arrow_down {
    flex-shrink: 0;
    -ms-flex-align: end;
    align-self: center;
}

.custom-dropdown {
    position: relative;
    width: 100%;
    // max-width: 300px;
    color: #fff;
}


.selected_label {
    line-height: 1;
    font-size: 14px;
}

.svg-icon {
    width: 20px;
    height: 20px;
}

.dropdown-arrow {
    font-size: 0.8rem;
    color: #b5b5b5;
}

.dropdown_normal {
    width: 100%;
}

.dropdown_wide {
    width: 300px;
    max-height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index: 4;
}

.label {
    width: 100%;
}

.dropdown_menu_select {
    position: absolute;
    top: 99%;
    left: 0;
    background-color: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
    display: flex;
    padding: 2px;
}

.dropdown_item {
    padding: 0.5rem;
    cursor: pointer;
    color: var(--Gray-700, #344054);
    width: 100%;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    user-select: none;
}

.dropdown_item:hover {
    background-color: #f5f5f5;
    border-radius: 8px;
}

.selected-item-menu {
    font-weight: 600;
    color: var(--text-color-selected-items);
    line-height: 20px;
}

.slide-enter-active,
.slide-leave-active {
    transition: max-height 0.05s ease;
}

.slide-enter {
    max-height: 0px;
}

.slide-leave-to {
    max-height: 0;
}

.dropdown_title {
    font-weight: 900;
    border-bottom: 1px solid #475467;
}

.dropdown_subitem {
    padding-left: 28px;
}

.list_list {
    width: 100%;
}
</style>